module.exports = __webpack_public_path__ + "media/icons/circle-dollar-477c9452.png";